import { PoiCategory } from "src/screens/interestPointsScreen/Create";

export function parsePoiCategory(category: string): string {
  const cat = category.trim().toUpperCase().replace("-", "_");
  if (Object.values(PoiCategory).includes(cat as PoiCategory)) {
    return category;
  }

  if (cat in PoiCategory) {
    return PoiCategory[cat as keyof typeof PoiCategory];
  }
  return category;
}
